module.exports = __webpack_public_path__ + "static/media/reward-r.dbe1a475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/reward-r.png
// module id = 1863
// module chunks = 0